"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var AvatarContent = function AvatarContent(_ref) {
  var image = _ref.image,
      initials = _ref.initials,
      height = _ref.height,
      width = _ref.width;

  var _useState = (0, _react.useState)(image),
      _useState2 = _slicedToArray(_useState, 2),
      imageSrc = _useState2[0],
      setImage = _useState2[1];

  var useInitials = image === '' && initials !== '';
  var borderRadius = height / 2;
  return useInitials ? _react["default"].createElement("div", {
    style: {
      height: height,
      width: width,
      borderRadius: borderRadius,
      backgroundColor: _colors["default"].steelBlue,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, _react["default"].createElement(_Typography["default"], {
    style: {
      color: _colors["default"].white
    }
  }, initials)) : _react["default"].createElement("img", {
    alt: "kt-avatar",
    src: imageSrc,
    style: {
      height: height,
      width: width,
      borderRadius: borderRadius,
      objectFit: 'cover'
    },
    onError: function onError(event) {
      return setImage(require('./avatar.png'));
    }
  });
};

AvatarContent.propTypes = {
  image: _propTypes["default"].string,
  initials: _propTypes["default"].string,
  height: _propTypes["default"].number.isRequired,
  width: _propTypes["default"].number.isRequired
};
AvatarContent.defaultProps = {
  image: '',
  initials: ''
};
var _default = AvatarContent;
exports["default"] = _default;